import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";

const TotalTrafficChart = ({ totalTrafic }) => {
  const areaRef = useRef(null);

  useEffect(() => {
    if (totalTrafic?.length > 0) {
      window.Apex = {
        chart: { foreColor: "#ccc", toolbar: { show: false } },
        stroke: { width: 3 },
        dataLabels: { enabled: false },
        tooltip: { theme: "dark" },
        grid: { borderColor: "#535A6C", xaxis: { lines: { show: true } } },
      };

      const mountChart = (ref, options) => {
        const el = ref.current;
        if (el) {
          const chart = new ApexCharts(el, options);
          chart.render();
        }
      };

      const quarters = totalTrafic?.map((m) => `${m.year} Q${m.quarter}`);

      const traficData = [
        {
          name: "countries",
          data: totalTrafic.map((item) => item.distinctCountries),
        },
        {
          name: "Provinces",
          data: totalTrafic.map((item) => item.distinctProvinces),
        },
        {
          name: "Cities",
          data: totalTrafic.map((item) => item.distinctCities),
        },
      ];
      const optionsArea = {
        chart: { height: 380, type: "area", stacked: false },
        stroke: { curve: "straight" },
        series: traficData,
        // series: [
        //   { name: "Country", data: [11, 15, 26, 20, 33, 27] },
        //   { name: "Provinces", data: [32, 33, 21, 42, 19, 32] },
        //   { name: "Cities", data: [20, 39, 52, 11, 29, 43] },
        // ],
        xaxis: {
          categories: quarters,
          // categories: [
          //   "2011",
          //   "2011",
          //   "2011",
          //   "2011",
          //   "2012",
          //   "2013",
          //   "2013",
          //   "2013",
          //   "2013",
          // ],
        },
        tooltip: { followCursor: true },
        fill: { opacity: 1 },
      };

      mountChart(areaRef, optionsArea);
    }
  }, [totalTrafic]);
  return (
    <div className="col-12 mt-4">
      <div className="box shadow p-4 rounded cardBox text-ligth">
        <h5 className="text-center fw-bold mb-3">Total Traffic</h5>
        <div id="areachart" ref={areaRef} />
      </div>
    </div>
  );
};
export default TotalTrafficChart;
